import { styled } from '@mui/material/styles';
import { Checkbox, FormControlLabel, Stack, TextField } from '@mui/material';
import { isDarkMode } from '@localstack/services';

export const CompactCheckbox = styled(Checkbox)(() => ({
  paddingTop: '2px',
  paddingBottom: '2px',
}));

export const CompactFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5),
}));

export const StyledSearchField = styled(TextField)(({ theme }) => ({
  minWidth: theme.spacing(38),
}));

export const StyledSectionDivider = styled(Stack)(({ theme }) => ({
  backgroundColor: isDarkMode(theme) ? theme.palette.background.paper : theme.palette.grey[100],
  padding: theme.spacing(1, 3.5),
  borderRadius: theme.shape.borderRadius,
}));
